import { render, staticRenderFns } from "./ChangeTemplateIcon.vue?vue&type=template&id=3dca2104&"
import script from "./ChangeTemplateIcon.vue?vue&type=script&lang=js&"
export * from "./ChangeTemplateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports